import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagService } from '../services/feature-flag/feature-flag.service';

export function featureFlagGuard(flagName: string): CanActivateFn {
  return () => {
    const router = inject(Router);
    const featureFlagService = inject(FeatureFlagService);
    const isEnabled = featureFlagService.funcionalidadeHabilitada(flagName);

    if (isEnabled) {
      return true;
    }

    return router.createUrlTree(['/home']);
  };
}
